import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import {
  Field, formValueSelector, getFormAsyncErrors, propTypes,
  reduxForm, SubmissionError,
} from 'redux-form';
import { ToastContainer, toast } from 'react-toastify';

import ContentWrapper from '../components/content-wrapper';
import { LargePrimaryButton } from '../components/button';
import TitledComponent from '../components/titled-component';
import { InlineInput } from '../components/inline-input';
import { connect } from 'react-redux';
import { redirectAction } from '../actions/redirect';
import SuccessModal from '../components/success-modal';
import {
  cellphoneExistValidator,
  cellphoneNumberNormalizer,
  cellphoneNumberValidator, genderValidator,
  heightWeightNormalizer, heightWeightValidator,
  nameNormalizer, parseError, passwordLengthValidator,
  passwordNormalizer, passwordValidator,
  required,
  verificationCodeNormalizer,
  verificationCodeValidator,
} from '../validator';
import { MEDICAL_HISTORY_FORM_NAME, medicalStatus } from './medical-history';
import { userRegister, } from '../actions/user';
import { GetVerificationButtonField } from '../components/input-field';
import { css } from 'emotion';
import { isIPhoneX } from '../util';

const toastStyle = {
  background: 'black',
  color: 'white',
  padding: '20px',
  borderRadius: '5px',
  boxShadow: '0 0 20px 2px grey',
};

const FlexWrapper = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
`;

const Stretcher = styled.div`
  background: #f2f2f2;
  min-height: 88px;
  flex-grow: 1;
`;

const CellPhoneTip = styled.div`
  width: 100%;
  height: 68px;
  background: #f0f0f0;
  font-size: 30px;
  color: rgb(249, 113, 62);
  text-align: center;
  line-height: 68px;
  
  &:before {
    content: "手机号：";
  }
`;

const GetCodeButton = css`
  width: 150px;
  height: 56px;
  font-size: 24px;
  color: white;
  line-height: 1;
`;

class _RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateModalOpen: false,
      lastDate: null,
    };
    this.renderCellphone = this.renderCellphone.bind(this);
    this.verifyMedicalHistory = this.verifyMedicalHistory.bind(this);
  }


  verifyMedicalHistory(values) {
    const { onSubmit, medicalHistoryVisited } = this.props;
    if (!medicalHistoryVisited) {
      throw new SubmissionError({
        medicalHistoryVisited: 'required',
      });
    }
    onSubmit(values);
  }

  renderCellphone(props) {
    const { meta: { error } } = props;
    return (
      <InlineInput label='手机号'>
        <InlineInput.Input {...props} />
        {
          error && error === 'taken' ?
            <InlineInput.More style={{
              marginRight: '20px',
              fontWeight: '500',
              color: 'rgb(255, 138, 95)',
            }}>已注册！
            </InlineInput.More>
            : null
        }
      </InlineInput>
    );
  }

  render() {
    const {
      handleSubmit, medicalHistoryVisited, invalidCellphone
    } = this.props;
    return (
      <form onSubmit={handleSubmit(this.verifyMedicalHistory)} style={{ height: '100%' }}>
        <FlexWrapper>
          <Field
            normalize={cellphoneNumberNormalizer}
            name='cellphone'
            component={this.renderCellphone}
            validate={cellphoneNumberValidator}
            type='number'
            pattern='\d*' />
          <InlineInput label='验证码'>
            <Field
              name='code'
              disabled={invalidCellphone}
              validate={verificationCodeValidator}
              normalize={verificationCodeNormalizer}
              component={InlineInput.Input}
              style={{ minWidth: '25%' }}
              type='number'
              pattern='\d*' />
            <InlineInput.More>
              <Field
                name='cellphone'
                disabled={invalidCellphone}
                component={GetVerificationButtonField}
                validate={cellphoneNumberValidator}
                className={GetCodeButton}
                scope='register'
              />
            </InlineInput.More>
          </InlineInput>
          <InlineInput label='设置密码'>
            <Field
              name='password'
              disabled={invalidCellphone}
              normalize={passwordNormalizer}
              validate={[passwordLengthValidator, passwordValidator]}
              component={InlineInput.Input}
              type='text'
              placeholder='6-12位字母数字组合'
            />
          </InlineInput>
          <InlineInput label='姓名'>
            <Field
              name='name'
              disabled={invalidCellphone}
              normalize={nameNormalizer}
              validate={required}
              component={InlineInput.Input}
              type='text' />
          </InlineInput>
            <InlineInput label='年龄'>
                <Field
                    name='age'
                    disabled={invalidCellphone}
                    normalize={heightWeightNormalizer}
                    validate={[required]}
                    component={InlineInput.Input}
                    type='text' />
                <InlineInput.More>
                    岁
                </InlineInput.More>
            </InlineInput>
          <Field
            name='gender'
            disabled={invalidCellphone}
            validate={genderValidator}
            component={InlineInput.RadioField} />
          <InlineInput label='身高 (厘米)'>
            <Field
              name='height'
              disabled={invalidCellphone}
              normalize={heightWeightNormalizer}
              validate={heightWeightValidator}
              component={InlineInput.Input}
              type='number'
              pattern='\d*' />
          </InlineInput>
          <InlineInput label='体重 (公斤)'>
            <Field
              name='weight'
              disabled={invalidCellphone}
              normalize={heightWeightNormalizer}
              validate={heightWeightValidator}
              component={InlineInput.Input}
              type='number'
              pattern='\d*' />
          </InlineInput>
          <InlineInput label='有无病史' onClick={() => !invalidCellphone && this.props.dispatch(redirectAction('/medicalhistory'))}>
            {
              medicalHistoryVisited ?
                <InlineInput.Input type='text' value={this.props.medicalHistory.map(s => medicalStatus[s]).join(', ') || '无'} readOnly /> :
                null
            }
            <InlineInput.More>
              {medicalHistoryVisited ? ' >' : '请选择 >'}
            </InlineInput.More>
          </InlineInput>
          <Stretcher />
          <LargePrimaryButton
            disabled={invalidCellphone}
            type='submit'
            style={{
              width: '100%',
              margin: '0',
            }}>
            注册
          </LargePrimaryButton>
          <div style={{ flexBasis: isIPhoneX() ? '96px' : '', flexShrink: '1', flexGrow: '0' }} />
        </FlexWrapper>
        {this.props.children}
      </form>
    );
  }
}

_RegisterForm.defaultProps = {
  children: null,
  medicalHistoryVisited: false,
  medicalHistory: [],
  invalidCellphone: false,
};

_RegisterForm.propTypes = {
  ...propTypes,
  children: PropTypes.node,
  medicalHistoryVisited: PropTypes.bool,
  medicalHistory: PropTypes.array,
  invalidCellphone: PropTypes.bool,
};

export const REGISTER_FORM_NAME = 'register';

const RegisterForm = reduxForm({
  form: REGISTER_FORM_NAME, // a unique name for this form
  destroyOnUnmount: false,
  asyncValidate: cellphoneExistValidator,
  asyncBlurFields: ['cellphone'],
  initialValues: {
    gender: -1,
  },
  onSubmitFail: (e) => {
    toast.dismiss();
    toast(
      parseError(e),
      {
        position: toast.POSITION.TOP_CENTER,
      }
    );
  },
})(_RegisterForm);

class Register extends TitledComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    this.props.dispatch(userRegister({
      ...e,
      medical_history: [...(this.props.medicalHistory || [])],
    }));
  }

  render() {
    const { cellphone, registerModalOpen } = this.props;
    return (
      <RegisterForm
        onSubmit={e => this.onSubmit(e)}
        dispatch={this.props.dispatch}
        medicalHistoryVisited={typeof this.props.medicalHistory !== 'undefined'}
        medicalHistory={this.props.medicalHistory}
        invalidCellphone={this.props.invalidCellphone}
      >
        <SuccessModal
          isOpen={registerModalOpen}
          title='注册成功'
          onRequestClose={() => null}
        >
          <CellPhoneTip>{ cellphone }</CellPhoneTip>
        </SuccessModal>
        <ToastContainer
          style={{
            width: 'auto',
            fontSize: '28px',
            textAlign: 'center',
            left: '50%',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
          }}
          toastClassName={toastStyle}
          closeButton={false}
          progressClassName={{ background: 'lightcoral' }}
        />
      </RegisterForm>
    );
  }
}

Register.defaultProps = {
  title: '注册',
};

const medicalHistorySelector = formValueSelector(MEDICAL_HISTORY_FORM_NAME);
const registerSelector = formValueSelector(REGISTER_FORM_NAME);
const registerAsyncErrorSelector = getFormAsyncErrors(REGISTER_FORM_NAME);

export default connect(state => ({
  medicalHistory: medicalHistorySelector(state, 'selected'),
  cellphone: registerSelector(state, 'cellphone'),
  registerModalOpen: state.user.registerModalOpen,
  invalidCellphone: (
    !!registerAsyncErrorSelector(state) && !!registerAsyncErrorSelector(state).cellphone
  ),
}))(Register);



// WEBPACK FOOTER //
// ./src/scene/register.jsx